import { ofType } from "redux-observable";
import { merge } from "rxjs";
import { combineChecks } from "../../../guards/combineChecks";
import { guard } from "../../../guards/guard";
import { invert } from "../../../guards/invert";
import { pathEmpty } from "../../../guards/pathEmpty";
import { TypeActionShowMe } from "../../actionShowMe";
import { checkAnyBuildingWhichProducesResourceIdAvailable } from "../../checks/checkAnyBuildingWhichProducesResourceIdAvailable";
import { checkAnyBuildingWhichProducesResourceIdNotProducingAvailable } from "../../checks/checkAnyBuildingWhichProducesResourceIdNotProducingAvailable";
import { checkAnyBuildingWhichProducesResourceIdNotProducingPremiumAvailable } from "../../checks/checkAnyBuildingWhichProducesResourceIdNotProducingPremiumAvailable";
import { checkAnyBuildingWhichProducesResourceIdProductionDoneOrConstructionDone } from "../../checks/checkAnyBuildingWhichProducesResourceIdProductionDoneOrConstructionDone";
import { pathFocusBuildingConstructionDoneProductionDoneMaxLevel } from "../../path/pathFocusBuildingConstructionDoneProductionDoneMaxLevel";
import { pathSelectBuildingInBuildMenuByResourceId } from "../../path/pathSelectBuildingInBuildMenuByResourceId";
import { pathSelectBuildingMaxLevelByResourceId } from "../../path/pathSelectBuildingMaxLevelByResourceId";
import { pathSelectBuildingNotProducingMaxLevelByResourceId } from "../../path/pathSelectBuildingNotProducingMaxLevelByResourceId";
import { pathSelectPremiumBuildingNotProducingMaxLevelByResourceId } from "../../path/pathSelectPremiumBuildingNotProducingMaxLevelByResourceId";
export var epicShowMeStartProduction = function (action$, state$, deps) {
    // TODO: Could Naming be done based on shopCategory?
    var action1 = action$.pipe(ofType(TypeActionShowMe.QuestTaskStartProduction), guard(state$, deps, pathEmpty)([
        combineChecks([invert(checkAnyBuildingWhichProducesResourceIdAvailable)])(pathSelectBuildingInBuildMenuByResourceId),
    ]));
    var action2 = action$.pipe(ofType(TypeActionShowMe.QuestTaskStartProduction), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkAnyBuildingWhichProducesResourceIdAvailable,
            checkAnyBuildingWhichProducesResourceIdNotProducingAvailable,
            checkAnyBuildingWhichProducesResourceIdNotProducingPremiumAvailable,
        ])(pathSelectPremiumBuildingNotProducingMaxLevelByResourceId),
    ]));
    var action3 = action$.pipe(ofType(TypeActionShowMe.QuestTaskStartProduction), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkAnyBuildingWhichProducesResourceIdAvailable,
            checkAnyBuildingWhichProducesResourceIdNotProducingAvailable,
            invert(checkAnyBuildingWhichProducesResourceIdNotProducingPremiumAvailable),
        ])(pathSelectBuildingNotProducingMaxLevelByResourceId),
    ]));
    var action4 = action$.pipe(ofType(TypeActionShowMe.QuestTaskStartProduction), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkAnyBuildingWhichProducesResourceIdAvailable,
            invert(checkAnyBuildingWhichProducesResourceIdNotProducingAvailable),
            checkAnyBuildingWhichProducesResourceIdProductionDoneOrConstructionDone,
        ])(pathFocusBuildingConstructionDoneProductionDoneMaxLevel),
    ]));
    var action5 = action$.pipe(ofType(TypeActionShowMe.QuestTaskStartProduction), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkAnyBuildingWhichProducesResourceIdAvailable,
            invert(checkAnyBuildingWhichProducesResourceIdNotProducingAvailable),
            invert(checkAnyBuildingWhichProducesResourceIdProductionDoneOrConstructionDone),
        ])(pathSelectBuildingMaxLevelByResourceId),
    ]));
    return merge(action1, action2, action3, action4, action5);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/start-production/epicShowMeStartProduction.ts
// module id = 2385
// module chunks = 3